import { i18n } from "@/main";
import { useAuthenticationStore } from "@/stores/authentication";
import { useGeolocationStore } from "@/stores/geolocation";
import { Geolocation } from "@capacitor/geolocation";
import { AlertButton, alertController, isPlatform } from "@ionic/vue";
import { io } from "socket.io-client";


let geoInterval: number;
const socketUrl: string = process.env.VUE_APP_SOCKET_URL || '';
let socket: any;

class GeolocationService {
    constructor() {
    }

    connectToSocketIo = async () => {
        /*const permissions = await Geolocation.checkPermissions();
        const userStore = useAuthenticationStore();
        const geolocationStore = useGeolocationStore();
        const user = userStore.user;
        socket = io(socketUrl);
        socket.emit('join group', user?.user_grouper_id);
        socket.emit('join driver', user?.driver_id);
        geolocationStore.geolocationLiveOn();

        if ((permissions.location === 'denied') && isPlatform('android')) {
            const okButton: AlertButton = {
                text: 'OK',
                handler: this.sendGeolocationToSocket,
                role: 'destroy'
            }
            const alert = await alertController.create({
                header: i18n.global.t('message.precise_location_permission_title'),
                message: i18n.global.t('message.precise_location_permission_description ') + permissions.location,
                buttons: [okButton]
            });

            alert.present();
        } else {
            await this.sendGeolocationToSocket();
        }*/
    }

    private async sendGeolocationToSocket() {
        /*geoInterval = setInterval(async () => {
            const coordinates = await Geolocation.getCurrentPosition();
            const userStore = useAuthenticationStore();
            const user = userStore.user;

            const data = {
                lat: coordinates.coords.latitude,
                lng: coordinates.coords.longitude,
                angle: coordinates.coords.heading || 90,
                name: user?.name
            };
            socket.emit('map', data);
        }, 10000);*/
    }

    async endSendingGeolocation() {
        /*if (socket) {
            socket.disconnect();
        }
        if (geoInterval) {
            clearInterval(geoInterval);
            const geolocationStore = useGeolocationStore();
            geolocationStore.geolocationLiveOff();
        }*/
    }
}

export default new GeolocationService();